import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INFO_PANE_PAGES, openInfoPane, toggleIsInfoPaneExpanded } from 'redux_store';

/**
 * Opens the patient page of the InfoPane for the given patient —
 * legacy semantics (1:1 with the old PatientInfoBlock second-style
 * click and claim-edit's openPatientPane): if the pane is closed or
 * showing a different patient, open it for this one; if it is already
 * showing this patient, just expand it.
 */
export const useOpenPatientPane = ({ patient, patientUuid, accountUuid }) => {
  const dispatch = useDispatch();
  const currentPage = useSelector(state => state.infoPane?.currentPage);

  return useCallback(() => {
    if (!patientUuid) return;
    const isPaneOpenForThisInfo =
      (currentPage?.currentPageContext?.patientUUID ?? currentPage?.currentPageContext?.uuid) ===
      patientUuid;
    if (currentPage?.currentPageName !== INFO_PANE_PAGES.patient_page || !isPaneOpenForThisInfo) {
      dispatch(
        openInfoPane({
          currentPageName: INFO_PANE_PAGES.patient_page,
          currentPageContext: {
            ...(patient || {}),
            uuid: patientUuid,
            accountUUID: accountUuid,
          },
        })
      );
    } else {
      dispatch(toggleIsInfoPaneExpanded(true));
    }
  }, [dispatch, currentPage, patient, patientUuid, accountUuid]);
};
